import { Text, Img } from "./..";
import React from "react";

export default function VerifiedContentWithStatistics({
  verificationText,
  titleText = "&lt;&gt;How To Create Restaurant P&L Trend&lt;br /&gt;Analysis?&lt;/&gt;",
  descriptionText = "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
  likeCount = "30",
  contrastCount = "50",
  downloadCount = "50",
  priceText = "300 EGP",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col justify-center w-[32%] md:w-full p-3 md:px-5 border-gray-100 border-[0.5px] border-solid bg-white-a700 rounded-[18px] sm:min-w-[358px]`}
    >
      <div className="flex items-center self-stretch">
        <Img src="images/img_checkmark.svg" alt="Verified By" className="h-[16px]" />
        <Text as="p" className="self-end text-[12px] font-normal">
          <span className="text-gray-700">Verified by&nbsp;</span>
          <span className="text-orange-900">Suplyd</span>
        </Text>
      </div>
      <div className="flex flex-col self-stretch">
        <Text size="text2xl" as="p" className="text-[16px] font-normal leading-5 !text-black-900_01">
          {titleText}
        </Text>
        <div className="flex flex-col gap-2">
          <Text as="p" className="text-[12px] font-normal leading-4 tracking-[0.50px] !text-gray-900_02">
            {descriptionText}
          </Text>
          <div className="flex items-center justify-center">
            <div className="flex flex-1 justify-center gap-1">
              <div className="flex items-center">
                <Img src="images/img_heart_rounded.svg" alt="Image" className="h-[16px]" />
                <Text as="p" className="self-end text-[12px] font-normal">
                  {likeCount}
                </Text>
              </div>
              <div className="flex items-center gap-1">
                <Img src="images/img_contrast.svg" alt="Image" className="h-[16px]" />
                <Text as="p" className="self-end text-[12px] font-normal">
                  {contrastCount}
                </Text>
              </div>
              <div className="flex flex-1 items-center px-1">
                <Img src="images/img_download.svg" alt="Image" className="h-[16px]" />
                <Text as="p" className="self-end text-[12px] font-normal">
                  {downloadCount}
                </Text>
              </div>
            </div>
            <Text size="text2xl" as="p" className="text-[16px] font-normal !text-orange-900">
              {priceText}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
